<template>
  <div :class="`userManagementConsole${isModalVisible ? ' modalVisible' : ''}`">
    <Header/>
    <!-- Below is our router view itself, which displays all content in the router's view -->
    <router-view/>
    <Footer/>
  </div>
</template>

<script>
import Header from './components/shared/Header.vue';
import Footer from './components/shared/Footer.vue';
import { mapGetters } from 'vuex';

export default {
  components: { Header, Footer },
  computed: mapGetters([
      'isModalVisible'
  ])
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 60px;
}

* {
  font-family: 'Noto Sans', sans-serif
}
.modalVisible {
  z-index: 1000000;
}

.userManagementConsole {
  position: relative;
  min-height: 100%;
}
</style>